import Link from "next/link";
import PropTypes from "prop-types";
import React from "react";

const CommonButton = ({ styles = {}, text, url }) => {
  let isInternal = true;

  const defaultStyles = {
    backgroundColor: "transparent",
    border: "1px solid #000",
    color: "#000",
    fontWeight: "bold",
    padding: "10px 25px",
  };

  if (url.includes("https") || url.includes("http")) {
    isInternal = false;
  }

  return (
    <div>
      {isInternal ? (
        <Link href={url} style={{ ...defaultStyles, ...styles }}>
          {text}
        </Link>
      ) : (
        <a
          href={url}
          rel="noopener noreferrer"
          style={{ ...defaultStyles, ...styles }}
          target="_blank"
        >
          {text}
        </a>
      )}
    </div>
  );
};

CommonButton.propTypes = {
  styles: PropTypes.object,
  text: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};

export default CommonButton;
